















































































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import Miembro from "@/models/miembro/miembro.model";
import GenericAdd from "@/core/Generics/GenericAdd";
import Helpers from "@/helpers/helper";
import moment from "moment";
import { AxiosResponse } from "axios";
import Persona from "../../models/persona/persona.model";
import { Utils } from "../../core/Utils";
import NameValue from "@/models/nameValue.model";
import { TipoTramiteCode } from "@/enums/TipoTramiteCode";
import DatePickerComponent from "@/components/base-datePicker/base-date-picker.vue";

@Component({
  components: {
    DatePickerComponent
  }
})
export default class MiembroAdd extends GenericAdd<Miembro> {
  @Prop() public controller!: string;
  @Prop() public action!: string;
  @Prop() public codigoHogar!: string;
  @Prop() public hogarId!: number;
  @Prop() public title!: string;
  @Prop() public sinCedula!: boolean;
  @Prop() public value!: Miembro;
  @Prop() public tramiteCode!: TipoTramiteCode;

  TipoTramiteCode = TipoTramiteCode;
  ciudadano: Persona | undefined | null = null;
  model = this.value || new Miembro();
  constructor() {
    super();
    this.exitOnSave = false;
    this.model.hogarId = this.hogarId;
    this.model.codigoHogar = this.codigoHogar;
    if (!this.model.persona) this.model.persona = new Persona();
  }

  get isInclusion() {
    return (
      this.tramiteCode == TipoTramiteCode.CambioComposicionFamiliarInclusion
    );
  }

  get isEvaluacionNuevoHogar() {
    return this.tramiteCode == TipoTramiteCode.EvaluacionNuevoHogar;
  }
  get esOtraRazon() {
    return this.model.razonInclusion
      ? this.model.razonInclusion.codigo == "RAZON_INCLUSION_OTRO"
      : false;
  }
   get edadText() {
    let fecha = (this.model.persona as Persona).fechaNacimiento;
    if (fecha) return Helpers.Filters.EdadText(fecha.toString());

    return "";
  }
  get edad() {
    let fecha = (this.model.persona as Persona).fechaNacimiento;
    if (fecha) return Helpers.Filters.Edad(fecha.toString());

    return "";
  }
  get isMobile() {
    return this.$store.state.isMobile;
  }
  foundCiudadano(value: any) {
    if (value) {
      this.ciudadano = value;
      this.model.personaId = value.id;
      this.model.persona = value;
      if (this.model.persona) {
        this.model.persona.fechaNacimiento = new Date(
          this.model.persona ? this.model.persona.fechaNacimiento : ("" as any)
        );
      }
    } else {
      //this.model = new Miembro();
      this.model.personaId = undefined;
      this.model.persona = new Persona();
    }
  }
  public async isValid() {
    try {
      let isValid = await this.$validator.validateAll();
      if (isValid) return true;

      throw this.$validator.errors.items.map(e => e.msg);
    } catch (errors) {
      this.operationFailedErrors(errors);
      return false;
    }
  }
  @Watch("model", { deep: true })
  onModelChange(value: Miembro) {
    this.$emit("input", value);
  }

  @Watch("value", { deep: true })
  onValueChange(value: Miembro) {
    this.model = value || new Miembro();
  }
  onSelectParentesco(value: NameValue) {
    this.model.parentescoNombre = value ? value.descripcion : String();
  }
}
